import { Component, Input } from '@angular/core';
import { UsefulLink } from '../../interfaces/useful-link';
@Component({
  selector: 'app-useful-links',
  templateUrl: './useful-links.component.html',
  styleUrls: ['./useful-links.component.scss']
})
export class UsefulLinksComponent {
  @Input() links!: UsefulLink[];
  @Input() title!: string;
}
